export default "__VITE_ASSET__DL56rrX9__"